import StudyingSubjectsApi from '@/api/studying-subjects';

export default {
  namespaced: true,
  state: {
    subjects: [],
  },

  mutations: {
    SET_SUBJECTS(state, val) {
      state.subjects = val;
    },
  },
  actions: {
    async getSubjects({ commit }) {
      try {
        const subjects = await StudyingSubjectsApi.getSubjects();
        commit('SET_SUBJECTS', subjects.data);
        return subjects;
      } catch (e) {
        throw e;
      }
    },
    async updateOrCreateSubject ({ commit, dispatch }, data) {
      try {
        const subject = await StudyingSubjectsApi.createOrUpdateSubject(data)
        dispatch('getSubjects');
        return subject
      } catch (e) {
        throw e;
      }
    },
    async deleteSubjectRecord({commit, dispatch}, data) {
      try {
        const subjectResponse = await StudyingSubjectsApi.removeSubject(data);
        dispatch('getSubjects');
        return subjectResponse;
      } catch (e) {
        throw e;
      }
    }
  },

};
